import {
  Patient,
  Doctor,
  Appointment,
  Contact,
  Opportunity,
  Service,
  Insurance,
  Specialty,
  ClinicalHistory,
  AuditLog } from
'../types';
import { formatDate, getGenderName, getStatusName } from './helpers';

// Logo circular Savidna (SV) embebido para encabezados de PDF
const SAVIDNA_LOGO_JPG = "data:image/jpeg;base64,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";
interface PdfColumn {
  header: string;
  key: string;
  width?: number;
}
interface PdfRow {
  [key: string]: string | number | boolean;
}
const downloadFormattedPdf = async (
data: PdfRow[],
columns: PdfColumn[],
filename: string,
title: string,
totalsRow?: PdfRow) =>
{
  if (data.length === 0) {
    alert('No hay datos para exportar');
    return;
  }

  // Dynamic import to avoid bundling jsPDF upfront
  const { default: jsPDF } = await import('jspdf');
  const doc = new jsPDF('l', 'mm', 'a4');
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 14;
  const contentWidth = pageWidth - margin * 2;
  const colors = {
    primary: [6, 182, 212] as [number, number, number],
    dark: [17, 24, 39] as [number, number, number],
    gray: [107, 114, 128] as [number, number, number],
    lightGray: [229, 231, 235] as [number, number, number],
    white: [255, 255, 255] as [number, number, number],
    headerBg: [6, 182, 212] as [number, number, number],
    rowEven: [240, 253, 250] as [number, number, number],
    accent: [6, 182, 212] as [number, number, number]
  };

  // Calculate column widths
  const totalDefinedWidth = columns.reduce((sum, c) => sum + (c.width || 0), 0);
  const colsWithoutWidth = columns.filter((c) => !c.width).length;
  const defaultWidth =
  colsWithoutWidth > 0 ?
  (contentWidth - (
  totalDefinedWidth > 0 ?
  totalDefinedWidth / 200 * contentWidth :
  0)) /
  colsWithoutWidth :
  contentWidth / columns.length;
  const colWidths = columns.map((c) => {
    if (c.width) return c.width / totalDefinedWidth * contentWidth * 0.9;
    return defaultWidth;
  });
  const totalColWidth = colWidths.reduce((s, w) => s + w, 0);
  const scale = contentWidth / totalColWidth;
  const finalWidths = colWidths.map((w) => w * scale);
  let y = margin;
  let pageNum = 1;
  const drawHeader = () => {
    doc.setFillColor(...colors.primary);
    doc.rect(0, 0, pageWidth, 3, 'F');
    y = 10;
    try {
      doc.addImage(SAVIDNA_LOGO_JPG, 'JPEG', margin, y - 2, 14, 14);
    } catch {



      // si el logo falla, se sigue sin él
    }const textX = margin + 18;doc.setFont('helvetica', 'bold');doc.setFontSize(18);
    doc.setTextColor(...colors.primary);
    doc.text(title, textX, y + 6);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(...colors.gray);
    doc.text(
      `Savidna - Centro de Bienestar y Belleza  |  ${data.length} registros  |  ${new Date().toLocaleDateString('es-DO')}`,
      textX,
      y + 13
    );
    y += 18;
    doc.setDrawColor(...colors.primary);
    doc.setLineWidth(0.5);
    doc.line(margin, y, pageWidth - margin, y);
    y += 4;
  };
  const drawTableHeader = () => {
    const rowHeight = 8;
    doc.setFillColor(...colors.headerBg);
    doc.rect(margin, y, contentWidth, rowHeight, 'F');
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7.5);
    doc.setTextColor(...colors.white);
    let x = margin + 2;
    columns.forEach((col, i) => {
      const text = doc.splitTextToSize(col.header, finalWidths[i] - 4);
      doc.text(text[0] || '', x, y + 5.5);
      x += finalWidths[i];
    });
    y += rowHeight + 1;
  };
  const drawFooter = () => {
    doc.setFillColor(...colors.primary);
    doc.rect(0, pageHeight - 3, pageWidth, 3, 'F');
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(7);
    doc.setTextColor(...colors.gray);
    doc.text(`Página ${pageNum}`, pageWidth / 2, pageHeight - 5, {
      align: 'center'
    });
    doc.text('Savidna - Documento Confidencial', margin, pageHeight - 5);
    doc.text(
      new Date().toLocaleDateString('es-DO'),
      pageWidth - margin,
      pageHeight - 5,
      {
        align: 'right'
      }
    );
  };
  drawHeader();
  drawTableHeader();
  const rowHeight = 7;
  data.forEach((row, rowIndex) => {
    if (y + rowHeight > pageHeight - 15) {
      drawFooter();
      doc.addPage();
      pageNum++;
      y = margin;
      drawHeader();
      drawTableHeader();
    }
    if (rowIndex % 2 === 0) {
      doc.setFillColor(...colors.rowEven);
      doc.rect(margin, y, contentWidth, rowHeight, 'F');
    }
    doc.setDrawColor(...colors.lightGray);
    doc.setLineWidth(0.1);
    doc.line(margin, y + rowHeight, margin + contentWidth, y + rowHeight);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(7);
    doc.setTextColor(...colors.dark);
    let x = margin + 2;
    columns.forEach((col, i) => {
      const value = String(row[col.key] ?? '');
      const maxChars = Math.floor(finalWidths[i] / 1.8);
      const truncated =
      value.length > maxChars ?
      value.substring(0, maxChars - 2) + '..' :
      value;
      doc.text(truncated, x, y + 4.8);
      x += finalWidths[i];
    });
    y += rowHeight;
  });
  if (totalsRow) {
    if (y + rowHeight > pageHeight - 15) {
      drawFooter();
      doc.addPage();
      pageNum++;
      y = margin;
      drawHeader();
      drawTableHeader();
    }
    doc.setFillColor(...colors.accent);
    doc.rect(margin, y, contentWidth, rowHeight + 1, 'F');
    doc.setDrawColor(...colors.primary);
    doc.setLineWidth(0.3);
    doc.line(margin, y, margin + contentWidth, y);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7.5);
    doc.setTextColor(...colors.white);
    let x = margin + 2;
    columns.forEach((col, i) => {
      const value = String(totalsRow[col.key] ?? '');
      const maxChars = Math.floor(finalWidths[i] / 1.8);
      const truncated =
      value.length > maxChars ?
      value.substring(0, maxChars - 2) + '..' :
      value;
      doc.text(truncated, x, y + 5);
      x += finalWidths[i];
    });
    y += rowHeight + 1;
  }
  drawFooter();
  doc.save(filename);
};

// ==================== EXPORT FUNCTIONS ====================

export const exportPatientsToPdf = (
patients: Patient[],
getInsuranceName: (id: string | null) => string) =>
{
  const columns: PdfColumn[] = [
  {
    header: 'Nombre',
    key: 'nombre',
    width: 200
  },
  {
    header: 'Sexo',
    key: 'sexo',
    width: 80
  },
  {
    header: 'Teléfono',
    key: 'telefono',
    width: 130
  },
  {
    header: 'Email',
    key: 'email',
    width: 200
  },
  {
    header: 'Dirección',
    key: 'direccion',
    width: 200
  },
  {
    header: 'Seguro',
    key: 'seguro',
    width: 150
  },
  {
    header: 'Registro',
    key: 'fecha',
    width: 100
  }];


  const data: PdfRow[] = patients.map((p) => ({
    nombre: p.name,
    sexo: getGenderName(p.gender),
    telefono: p.phone,
    email: p.email,
    direccion: p.address,
    seguro: getInsuranceName(p.insuranceId),
    fecha: formatDate(p.createdAt)
  }));
  const ts = new Date().toISOString().split('T')[0];
  downloadFormattedPdf(
    data,
    columns,
    `pacientes_${ts}.pdf`,
    'Listado de Pacientes'
  );
};
export const exportDoctorsToPdf = (
doctors: Doctor[],
getSpecialtyName: (id: string) => string) =>
{
  const columns: PdfColumn[] = [
  {
    header: 'Nombre',
    key: 'nombre',
    width: 200
  },
  {
    header: 'Especialidad',
    key: 'especialidad',
    width: 200
  },
  {
    header: 'Teléfono',
    key: 'telefono',
    width: 150
  },
  {
    header: 'Email',
    key: 'email',
    width: 250
  },
  {
    header: 'Registro',
    key: 'fecha',
    width: 120
  }];


  const data: PdfRow[] = doctors.map((d) => ({
    nombre: d.name,
    especialidad: getSpecialtyName(d.specialtyId),
    telefono: d.phone,
    email: d.email,
    fecha: formatDate(d.createdAt)
  }));
  const ts = new Date().toISOString().split('T')[0];
  downloadFormattedPdf(
    data,
    columns,
    `doctores_${ts}.pdf`,
    'Listado de Doctores'
  );
};
export const exportAppointmentsToPdf = (
appointments: Appointment[],
getPatientName: (id: string) => string,
getDoctorName: (id: string) => string,
getServiceName: (id: string) => string,
getServicePrice: (id: string) => number,



getDiscountPercent?: (appointment: Appointment, serviceId: string) => number) =>
{
  const columns: PdfColumn[] = [
  {
    header: 'Paciente',
    key: 'paciente',
    width: 170
  },
  {
    header: 'Doctor',
    key: 'doctor',
    width: 170
  },
  {
    header: 'Servicio',
    key: 'servicio',
    width: 150
  },
  {
    header: 'Fecha',
    key: 'fecha',
    width: 90
  },
  {
    header: 'Hora',
    key: 'hora',
    width: 60
  },
  {
    header: 'Duración',
    key: 'duracion',
    width: 60
  },
  {
    header: 'Subtotal',
    key: 'subtotal',
    width: 85
  },
  {
    header: 'Desc.',
    key: 'descuentoDetalle',
    width: 60
  },
  {
    header: 'Descuento',
    key: 'descuento',
    width: 85
  },
  {
    header: 'Total (DOP)',
    key: 'total',
    width: 90
  },
  {
    header: 'Estado',
    key: 'estado',
    width: 90
  },
  {
    header: 'Creada por',
    key: 'creadaPor',
    width: 120
  },
  {
    header: 'Notas',
    key: 'notas',
    width: 120
  }];


  const data: PdfRow[] = appointments.map((a) => {
    const serviceIds =
    a.serviceIds && a.serviceIds.length > 0 ?
    a.serviceIds :
    [a.serviceId].filter(Boolean);
    const serviceNames = serviceIds.map((id) => getServiceName(id)).join(', ');
    const discounts = a.serviceDiscounts || {};
    const resolveDiscount = (id: string) =>
    getDiscountPercent ?
    Number(getDiscountPercent(a, id) || 0) :
    Number(discounts[id] || 0);
    const subtotal = serviceIds.reduce(
      (sum, id) => sum + (getServicePrice(id) || 0),
      0
    );
    const descuento = serviceIds.reduce((sum, id) => {
      const price = getServicePrice(id) || 0;
      return sum + price * (resolveDiscount(id) / 100);
    }, 0);
    const total = Math.max(0, subtotal - descuento);
    const pcts = Array.from(
      new Set(serviceIds.map((id) => resolveDiscount(id)).filter((p) => p > 0))
    );
    const descuentoDetalle =
    pcts.length === 0 ? '—' : pcts.map((p) => `-${p}%`).join(' / ');
    return {
      paciente: getPatientName(a.patientId),
      doctor: getDoctorName(a.doctorId),
      servicio: serviceNames,
      fecha: a.date,
      hora: a.time,
      duracion: `${a.duration} min`,
      subtotal,
      descuentoDetalle,
      descuento,
      total,
      estado: getStatusName(a.status),
      creadaPor: a.createdByUserName || '—',
      notas: a.notes || ''
    };
  });
  const grandTotal = data.reduce((sum, row) => sum + (Number(row.total) || 0), 0);
  const formatCurrencyLocal = (n: number) =>
  new Intl.NumberFormat('es-DO', {
    style: 'currency',
    currency: 'DOP',
    minimumFractionDigits: 0
  }).format(n);
  const ts = new Date().toISOString().split('T')[0];
  const grandSubtotal = data.reduce(
    (sum, row) => sum + (Number(row.subtotal) || 0),
    0
  );
  const grandDiscount = data.reduce(
    (sum, row) => sum + (Number(row.descuento) || 0),
    0
  );
  downloadFormattedPdf(data, columns, `citas_${ts}.pdf`, 'Listado de Citas', {
    servicio: 'TOTAL GENERAL',
    subtotal: formatCurrencyLocal(grandSubtotal),
    descuento: formatCurrencyLocal(grandDiscount),
    total: formatCurrencyLocal(grandTotal)
  });
};
export const exportServicesToPdf = (services: Service[]) => {
  const columns: PdfColumn[] = [
  {
    header: 'Nombre',
    key: 'nombre',
    width: 250
  },
  {
    header: 'Duración (min)',
    key: 'duracion',
    width: 100
  },
  {
    header: 'Precio (DOP)',
    key: 'precio',
    width: 120
  },
  {
    header: 'Descripción',
    key: 'descripcion',
    width: 400
  }];


  const data: PdfRow[] = services.map((s) => ({
    nombre: s.name,
    duracion: s.duration,
    precio: s.price,
    descripcion: s.description || ''
  }));
  const ts = new Date().toISOString().split('T')[0];
  downloadFormattedPdf(
    data,
    columns,
    `servicios_${ts}.pdf`,
    'Listado de Servicios'
  );
};
export const exportInsurancesToPdf = (insurances: Insurance[]) => {
  const columns: PdfColumn[] = [
  {
    header: 'Nombre',
    key: 'nombre',
    width: 200
  },
  {
    header: 'Compañía',
    key: 'compania',
    width: 200
  },
  {
    header: 'Cobertura',
    key: 'cobertura',
    width: 150
  },
  {
    header: 'Teléfono',
    key: 'telefono',
    width: 150
  },
  {
    header: 'Email',
    key: 'email',
    width: 250
  }];


  const data: PdfRow[] = insurances.map((i) => ({
    nombre: i.name,
    compania: i.company,
    cobertura: i.coverageType,
    telefono: i.phone,
    email: i.email
  }));
  const ts = new Date().toISOString().split('T')[0];
  downloadFormattedPdf(data, columns, `seguros_${ts}.pdf`, 'Listado de Seguros');
};
export const exportSpecialtiesToPdf = (specialties: Specialty[]) => {
  const columns: PdfColumn[] = [
  {
    header: 'Nombre',
    key: 'nombre',
    width: 250
  },
  {
    header: 'Descripción',
    key: 'descripcion',
    width: 500
  }];


  const data: PdfRow[] = specialties.map((s) => ({
    nombre: s.name,
    descripcion: s.description
  }));
  const ts = new Date().toISOString().split('T')[0];
  downloadFormattedPdf(
    data,
    columns,
    `especialidades_${ts}.pdf`,
    'Listado de Especialidades'
  );
};
export const exportContactsToPdf = (contacts: Contact[]) => {
  const columns: PdfColumn[] = [
  {
    header: 'Nombre',
    key: 'nombre',
    width: 180
  },
  {
    header: 'Empresa',
    key: 'empresa',
    width: 180
  },
  {
    header: 'Cargo',
    key: 'cargo',
    width: 130
  },
  {
    header: 'Teléfono',
    key: 'telefono',
    width: 130
  },
  {
    header: 'Email',
    key: 'email',
    width: 200
  },
  {
    header: 'Notas',
    key: 'notas',
    width: 200
  }];


  const data: PdfRow[] = contacts.map((c) => ({
    nombre: c.name,
    empresa: c.company,
    cargo: c.position,
    telefono: c.phone,
    email: c.email,
    notas: c.notes || ''
  }));
  const ts = new Date().toISOString().split('T')[0];
  downloadFormattedPdf(
    data,
    columns,
    `contactos_${ts}.pdf`,
    'Listado de Contactos'
  );
};
export const exportCompaniesToPdf = (companies: any[]) => {
  const columns: PdfColumn[] = [
  {
    header: 'Nombre',
    key: 'nombre',
    width: 180
  },
  {
    header: 'Industria',
    key: 'industria',
    width: 130
  },
  {
    header: 'Tamaño',
    key: 'tamano',
    width: 100
  },
  {
    header: 'Ubicación',
    key: 'ubicacion',
    width: 130
  },
  {
    header: 'Teléfono',
    key: 'telefono',
    width: 130
  },
  {
    header: 'Email',
    key: 'email',
    width: 200
  },
  {
    header: 'Sitio Web',
    key: 'sitioWeb',
    width: 180
  }];


  const data: PdfRow[] = companies.map((c) => ({
    nombre: c.name,
    industria: c.industry,
    tamano: c.size,
    ubicacion: c.location,
    telefono: c.phone,
    email: c.email,
    sitioWeb: c.website || ''
  }));
  const ts = new Date().toISOString().split('T')[0];
  downloadFormattedPdf(
    data,
    columns,
    `empresas_${ts}.pdf`,
    'Listado de Empresas'
  );
};
export const exportOpportunitiesToPdf = (opportunities: Opportunity[]) => {
  const columns: PdfColumn[] = [
  {
    header: 'Nombre',
    key: 'nombre',
    width: 180
  },
  {
    header: 'Empresa',
    key: 'empresa',
    width: 150
  },
  {
    header: 'Etapa',
    key: 'etapa',
    width: 130
  },
  {
    header: 'Monto (DOP)',
    key: 'monto',
    width: 100
  },
  {
    header: 'Probabilidad',
    key: 'probabilidad',
    width: 80
  },
  {
    header: 'Notas',
    key: 'notas',
    width: 250
  },
  {
    header: 'Fecha',
    key: 'fecha',
    width: 100
  }];


  const data: PdfRow[] = opportunities.map((o) => ({
    nombre: o.name,
    empresa: o.company,
    etapa: o.stage,
    monto: o.amount,
    probabilidad: `${o.probability}%`,
    notas: o.notes || '',
    fecha: formatDate(o.createdAt)
  }));
  const ts = new Date().toISOString().split('T')[0];
  downloadFormattedPdf(
    data,
    columns,
    `oportunidades_${ts}.pdf`,
    'Listado de Oportunidades'
  );
};
export const exportClinicalHistoriesToPdf = (
histories: ClinicalHistory[],
getPatientName: (id: string) => string) =>
{
  const columns: PdfColumn[] = [
  {
    header: 'Paciente',
    key: 'paciente',
    width: 180
  },
  {
    header: 'Doctor',
    key: 'doctor',
    width: 180
  },
  {
    header: 'Fecha',
    key: 'fecha',
    width: 100
  },
  {
    header: 'Motivo',
    key: 'motivo',
    width: 250
  },
  {
    header: 'Diagnóstico',
    key: 'diagnostico',
    width: 250
  },
  {
    header: 'Tratamiento',
    key: 'tratamiento',
    width: 250
  }];


  const data: PdfRow[] = histories.map((h) => ({
    paciente: getPatientName(h.patientId),
    doctor: h.doctorName,
    fecha: formatDate(h.date),
    motivo: h.personalBackground.consultationReason || '',
    diagnostico: h.diagnosis || '',
    tratamiento: h.treatment || ''
  }));
  const ts = new Date().toISOString().split('T')[0];
  downloadFormattedPdf(
    data,
    columns,
    `historiales_clinicos_${ts}.pdf`,
    'Historiales Clínicos'
  );
};
export const exportFollowUpNotesToPdf = (notes: any[]) => {
  const cleanText = (text: any): string => {
    if (!text) return '';
    let cleaned = String(text);
    cleaned = cleaned.replace(/[\u0000-\u001F\u007F-\u009F]/g, '');
    cleaned = cleaned.replace(/[\u2018\u2019]/g, "'");
    cleaned = cleaned.replace(/[\u201C\u201D]/g, '"');
    cleaned = cleaned.replace(/\u2013/g, '-');
    cleaned = cleaned.replace(/\u2014/g, '--');
    cleaned = cleaned.replace(/\u2026/g, '...');
    cleaned = cleaned.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '');
    cleaned = cleaned.replace(/[\u2600-\u27BF]/g, '');
    return cleaned.trim();
  };
  const columns: PdfColumn[] = [
  {
    header: 'Fecha',
    key: 'fecha',
    width: 120
  },
  {
    header: 'Usuario',
    key: 'usuario',
    width: 180
  },
  {
    header: 'Contacto',
    key: 'contacto',
    width: 180
  },
  {
    header: 'Asunto',
    key: 'asunto',
    width: 220
  },
  {
    header: 'Descripción',
    key: 'descripcion',
    width: 350
  }];


  const data: PdfRow[] = notes.map((n) => ({
    fecha: formatDate(n.createdAt),
    usuario: cleanText(n.userName),
    contacto: cleanText(n.contactName),
    asunto: cleanText(n.subject),
    descripcion: cleanText(n.description)
  }));
  const ts = new Date().toISOString().split('T')[0];
  downloadFormattedPdf(
    data,
    columns,
    `notas_seguimiento_${ts}.pdf`,
    'Notas de Seguimiento'
  );
};
export const exportAuditLogsToPdf = (auditLogs: AuditLog[]) => {
  const getActionName = (action: string): string => {
    switch (action) {
      case 'create':
        return 'Creación';
      case 'update':
        return 'Actualización';
      case 'delete':
        return 'Eliminación';
      case 'complete':
        return 'Completado';
      case 'cancel':
        return 'Cancelación';
      case 'reschedule':
        return 'Reprogramación';
      default:
        return action;
    }
  };
  const columns: PdfColumn[] = [
  {
    header: 'Fecha y Hora',
    key: 'fechaHora',
    width: 150
  },
  {
    header: 'Usuario',
    key: 'usuario',
    width: 160
  },
  {
    header: 'Acción',
    key: 'accion',
    width: 100
  },
  {
    header: 'Módulo',
    key: 'modulo',
    width: 100
  },
  {
    header: 'Entidad',
    key: 'entidad',
    width: 160
  },
  {
    header: 'Detalles',
    key: 'detalles',
    width: 300
  }];


  const data: PdfRow[] = auditLogs.map((log) => ({
    fechaHora: new Date(log.timestamp).toLocaleString('es-DO', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'America/Santo_Domingo'
    }),
    usuario: log.userName,
    accion: getActionName(log.action),
    modulo: log.module.charAt(0).toUpperCase() + log.module.slice(1),
    entidad: log.entityName,
    detalles: log.details
  }));
  const ts = new Date().toISOString().split('T')[0];
  downloadFormattedPdf(
    data,
    columns,
    `bitacora_${ts}.pdf`,
    'Bitácora de Auditoría'
  );
};

export const exportDashboardRevenueToPdf = (
aptRows: any[],
productRows: any[],
dateFrom: string,
dateTo: string) =>
{
  const fmt = (n: number) =>
  n.toLocaleString('es-DO', { style: 'currency', currency: 'DOP' });
  const totalSvc = aptRows.reduce((a, b) => a + b.total, 0);
  const totalProd = productRows.reduce((a, b) => a + b.total, 0);
  const totalGen = totalSvc + totalProd;

  const today = new Date().toLocaleDateString('es-DO', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  const combinedRows = [
  ...aptRows.map((r) => ({ ...r, type: 'Cita', concepto: r.service })),
  ...productRows.map((r) => ({
    ...r,
    type: 'Producto',
    concepto: r.product
  }))].
  sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

  const combinedTableRows = combinedRows.
  map(
    (r, i) => `
    <tr class="${i % 2 === 0 ? 'even' : ''}">
      <td>${r.date}</td>
      <td>${r.patient}</td>
      <td>${r.concepto}</td>
      <td>${r.colaborador || '—'}</td>
      <td class="right amount">${fmt(r.total)}</td>
    </tr>`
  ).
  join('');

  const totalRow =
  combinedRows.length > 0 ?
  `
    <tr class="total-row">
      <td colspan="4" class="right">Total General</td>
      <td class="right amount">${fmt(totalGen)}</td>
    </tr>` :
  '';

  const cssText = [
  '* { margin: 0; padding: 0; box-sizing: border-box; }',
  'body { font-family: Arial, sans-serif; font-size: 10px; color: #1f2937; background: #fff; }',
  '.header { background: linear-gradient(135deg, #0d9488, #0f766e); color: white; padding: 28px 36px 22px; }',
  '.header h1 { font-size: 22px; font-weight: 700; margin-bottom: 4px; }',
  '.header p { font-size: 10px; opacity: 0.85; }',
  '.header-meta { display: flex; gap: 24px; margin-top: 12px; }',
  '.header-meta span { background: rgba(255,255,255,0.15); border-radius: 20px; padding: 3px 12px; font-size: 9px; font-weight: 600; }',
  '.summary { display: flex; gap: 12px; padding: 20px 36px; background: #f8fafc; border-bottom: 1px solid #e2e8f0; }',
  '.summary-card { flex: 1; background: white; border-radius: 10px; padding: 14px 18px; border-left: 4px solid #0d9488; box-shadow: 0 1px 4px rgba(0,0,0,0.08); }',
  '.summary-card.purple { border-left-color: #7c3aed; }',
  '.summary-card.pink { border-left-color: #db2777; }',
  '.summary-card label { display: block; font-size: 8.5px; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 4px; }',
  '.summary-card strong { font-size: 15px; font-weight: 700; color: #111827; }',
  '.section { padding: 18px 36px 0; }',
  '.section-title { font-size: 11px; font-weight: 700; color: #0f766e; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 10px; padding-bottom: 6px; border-bottom: 2px solid #0d9488; display: flex; align-items: center; gap: 6px; }',
  '.section-title::before { content: ""; display: inline-block; width: 8px; height: 8px; background: #0d9488; border-radius: 50%; }',
  'table { width: 100%; border-collapse: collapse; margin-bottom: 24px; }',
  'thead tr { background: #134e4a; color: white; }',
  'thead th { padding: 8px 10px; text-align: left; font-size: 8.5px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.4px; }',
  'thead th.right { text-align: right; }',
  'tbody td { padding: 7px 10px; font-size: 9.5px; color: #374151; border-bottom: 1px solid #f1f5f9; }',
  'tbody tr.even td { background: #f8fafc; }',
  'tr.total-row td { background: #ecfdf5; font-weight: bold; font-size: 11px; border-top: 2px solid #10b981; }',
  'tr.total-row td.amount { color: #059669; }',
  'td.right { text-align: right; }',
  'td.amount { color: #059669; font-weight: 700; }',
  '.empty-row td { text-align: center; color: #9ca3af; font-style: italic; padding: 16px; }',
  '.footer { margin-top: 24px; background: #134e4a; color: rgba(255,255,255,0.7); padding: 10px 36px; display: flex; justify-content: space-between; font-size: 8px; }',
  '.footer span { color: white; font-weight: 600; }',
  '@media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } @page { margin: 10mm; size: A4 portrait; } }'].
  join('\n');

  const html = `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <title>Ingresos</title>
  <style>${cssText}</style>
</head>
<body>
  <div class="header">
    <h1>Reporte de Ingresos</h1>
    <p>Savidna - Centro de Bienestar y Belleza</p>
    <div class="header-meta">
      <span>Período: ${dateFrom} — ${dateTo}</span>
      <span>${aptRows.length} citas</span>
      <span>${productRows.length} productos</span>
      <span>${today}</span>
    </div>
  </div>
  <div class="summary">
    <div class="summary-card">
      <label>Ingresos Servicios</label>
      <strong>${fmt(totalSvc)}</strong>
    </div>
    <div class="summary-card purple">
      <label>Ingresos Productos</label>
      <strong>${fmt(totalProd)}</strong>
    </div>
    <div class="summary-card pink">
      <label>Total General</label>
      <strong>${fmt(totalGen)}</strong>
    </div>
  </div>
  <div class="section">
    <div class="section-title">Detalle de Ingresos</div>
    <table>
      <thead>
        <tr>
          <th>Fecha</th><th>Paciente</th><th>Concepto</th><th>Colaborador</th>
          <th class="right">Total</th>
        </tr>
      </thead>
      <tbody>
        ${combinedTableRows || '<tr class="empty-row"><td colspan="4">Sin registros en este período</td></tr>'}
        ${totalRow}
      </tbody>
    </table>
  </div>
  <div class="footer">
    <span>Savidna - Documento Confidencial</span>
    <span>Reporte de Ingresos</span>
    <span>${today}</span>
  </div>
</body>
</html>`;

  const win = window.open('', '_blank');
  if (win) {
    win.document.write(html);
    win.document.close();
    win.focus();
    setTimeout(() => {
      win.print();
    }, 600);
  }
};

// ==================== DASHBOARD & STATS EXPORT FUNCTIONS ====================

export const exportDashboardChartDataToPdf = (
chartData: {
  label: string;
  values: Record<string, string | number>;
}[],
columns: {
  header: string;
  key: string;
}[],
title: string,
dateRange?: {
  from: string;
  to: string;
}) =>
{
  const pdfColumns: PdfColumn[] = columns.map((c) => ({
    header: c.header,
    key: c.key,
    width: Math.max(100, Math.floor(900 / columns.length))
  }));
  const data: PdfRow[] = chartData.map((item) => ({
    ...item.values
  }));
  const dateInfo = dateRange ? ` (${dateRange.from} al ${dateRange.to})` : '';
  const ts = new Date().toISOString().split('T')[0];
  const filename = title.
  toLowerCase().
  replace(/[^a-z0-9]+/g, '_').
  replace(/_+$/, '');
  downloadFormattedPdf(
    data,
    pdfColumns,
    `${filename}_${ts}.pdf`,
    `${title}${dateInfo}`
  );
};
export const exportServiceDetailToPdf = (
serviceData: {
  name: string;
  count: number;
  totalRevenue: number;
  avgPerAppointment: number;
  percentOfTotal: number;
}[],
grandTotalRevenue: number,
grandTotalCount: number,
dateRange?: {
  from: string;
  to: string;
}) =>
{
  const columns: PdfColumn[] = [
  {
    header: 'Servicio',
    key: 'servicio',
    width: 250
  },
  {
    header: 'Cantidad',
    key: 'cantidad',
    width: 100
  },
  {
    header: 'Ingresos Totales',
    key: 'ingresos',
    width: 150
  },
  {
    header: 'Promedio / Cita',
    key: 'promedio',
    width: 150
  },
  {
    header: '% del Total',
    key: 'porcentaje',
    width: 100
  }];


  const formatCurrencyLocal = (n: number) =>
  new Intl.NumberFormat('es-DO', {
    style: 'currency',
    currency: 'DOP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(n);
  const data: PdfRow[] = [
  ...serviceData.map((s) => ({
    servicio: s.name,
    cantidad: s.count,
    ingresos: formatCurrencyLocal(s.totalRevenue),
    promedio: s.count > 0 ? formatCurrencyLocal(s.avgPerAppointment) : '-',
    porcentaje: `${s.percentOfTotal.toFixed(1)}%`
  })),
  {
    servicio: 'TOTAL',
    cantidad: grandTotalCount,
    ingresos: formatCurrencyLocal(grandTotalRevenue),
    promedio:
    grandTotalCount > 0 ?
    formatCurrencyLocal(grandTotalRevenue / grandTotalCount) :
    '-',
    porcentaje: '100%'
  }];


  const dateInfo = dateRange ? ` (${dateRange.from} al ${dateRange.to})` : '';
  const ts = new Date().toISOString().split('T')[0];
  downloadFormattedPdf(
    data,
    columns,
    `detalle_servicios_${ts}.pdf`,
    `Detalle por Servicio${dateInfo}`
  );
};
export const exportRevenueRankingToPdf = (
rankingData: {
  name: string;
  amount: number;
  count?: number;
}[],
title: string,
dateRange?: {
  from: string;
  to: string;
}) =>
{
  const formatCurrencyLocal = (n: number) =>
  new Intl.NumberFormat('es-DO', {
    style: 'currency',
    currency: 'DOP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(n);
  const hasCount = rankingData.some((d) => d.count !== undefined);
  const columns: PdfColumn[] = [
  {
    header: '#',
    key: 'posicion',
    width: 50
  },
  {
    header: 'Nombre',
    key: 'nombre',
    width: 300
  },
  ...(hasCount ?
  [
  {
    header: 'Citas',
    key: 'citas',
    width: 100
  } as PdfColumn] :

  []),
  {
    header: 'Ingresos',
    key: 'ingresos',
    width: 200
  }];


  const totalAmount = rankingData.reduce((s, d) => s + d.amount, 0);
  const data: PdfRow[] = [
  ...rankingData.map((d, i) => ({
    posicion: i + 1,
    nombre: d.name,
    ...(hasCount ?
    {
      citas: d.count || 0
    } :
    {}),
    ingresos: formatCurrencyLocal(d.amount)
  })),
  {
    posicion: '',
    nombre: 'TOTAL',
    ...(hasCount ?
    {
      citas: rankingData.reduce((s, d) => s + (d.count || 0), 0)
    } :
    {}),
    ingresos: formatCurrencyLocal(totalAmount)
  }];


  const dateInfo = dateRange ? ` (${dateRange.from} al ${dateRange.to})` : '';
  const ts = new Date().toISOString().split('T')[0];
  const filename = title.
  toLowerCase().
  replace(/[^a-z0-9]+/g, '_').
  replace(/_+$/, '');
  downloadFormattedPdf(
    data,
    columns,
    `${filename}_${ts}.pdf`,
    `${title}${dateInfo}`
  );
};
export const exportProductsToPdf = (
products: {
  id: string;
  name: string;
  sku: string;
  category: string;
  price: number;
  cost: number;
  stock: number;
  status: string;
  description?: string;
}[]) =>
{
  const columns: PdfColumn[] = [
  {
    header: 'Nombre',
    key: 'nombre',
    width: 180
  },
  {
    header: 'SKU',
    key: 'sku',
    width: 100
  },
  {
    header: 'Categoría',
    key: 'categoria',
    width: 120
  },
  {
    header: 'Precio',
    key: 'precio',
    width: 100
  },
  {
    header: 'Costo',
    key: 'costo',
    width: 100
  },
  {
    header: 'Stock',
    key: 'stock',
    width: 70
  },
  {
    header: 'Estado',
    key: 'estado',
    width: 90
  }];


  const data: PdfRow[] = products.map((p) => ({
    nombre: p.name,
    sku: p.sku || '',
    categoria: p.category || '',
    precio: `RD$ ${p.price.toLocaleString('es-DO')}`,
    costo: `RD$ ${p.cost.toLocaleString('es-DO')}`,
    stock: p.stock,
    estado:
    p.status === 'active' ?
    'Activo' :
    p.status === 'inactive' ?
    'Inactivo' :
    p.status === 'archived' ?
    'Archivado' :
    p.status
  }));
  const ts = new Date().toISOString().split('T')[0];
  downloadFormattedPdf(
    data,
    columns,
    `productos_${ts}.pdf`,
    'Listado de Productos'
  );
};
export const exportProductSalesToPdf = async (
sales: any[],
getPatientName: (id: string) => string,
dateFrom?: string | null,
dateTo?: string | null) =>
{
  const columns: PdfColumn[] = [
  {
    header: 'Fecha',
    key: 'fecha',
    width: 60
  },
  {
    header: 'Cliente',
    key: 'cliente',
    width: 120
  },
  {
    header: 'Vendedor',
    key: 'vendedor',
    width: 120
  },
  {
    header: 'Productos',
    key: 'productos',
    width: 180
  },
  {
    header: 'Total',
    key: 'total',
    width: 70
  },
  {
    header: 'Descuento',
    key: 'descuento',
    width: 70
  }];


  let data2export = sales;
  if (dateFrom && dateTo) {
    data2export = sales.filter((s: any) => {
      const d = (s.date || '').toString().split('T')[0];
      return d >= dateFrom && d <= dateTo;
    });
  }
  const data: PdfRow[] = data2export.map((s: any) => ({
    fecha: (s.date || '').toString().split('T')[0],
    cliente: getPatientName(s.patientId),
    vendedor: s.createdByUserName || '',
    productos: Array.isArray(s.items) ?
    s.items.
    map(
      (it: any) =>
      `${it.quantity || 1}x ${it.productName || it.productId || ''}`
    ).
    join(', ') :
    '',
    total: `RD$ ${Number(s.total || 0).toLocaleString('es-DO')}`,
    descuento: `RD$ ${Number(s.discountTotal || s.discount_total || 0).toLocaleString('es-DO')}`
  }));
  // Totales de las ventas exportadas
  const money = (n: number) => `RD$ ${n.toLocaleString('es-DO')}`;
  const totalVentas = data2export.reduce(
    (sum: number, s: any) => sum + Number(s.total || 0),
    0
  );
  const totalDescuentos = data2export.reduce(
    (sum: number, s: any) =>
    sum + Number(s.discountTotal || s.discount_total || 0),
    0
  );

  const ts = new Date().toISOString().split('T')[0];
  await downloadFormattedPdf(
    data,
    columns,
    `ventas_productos_${ts}.pdf`,
    'Ventas de Productos',
    {
      productos: 'TOTAL GENERAL',
      total: money(totalVentas),
      descuento: money(totalDescuentos)
    }
  );
};
export const exportProductStatsToPdf = async (
productStats: any[],
revenueTrend: any[],
totals: {
  revenue: number;
  units: number;
  profit: number;
},
dateFrom?: string | null,
dateTo?: string | null) =>
{
  const columns: PdfColumn[] = [
  {
    header: 'Producto',
    key: 'producto',
    width: 200
  },
  {
    header: 'Unidades',
    key: 'unidades',
    width: 90
  },
  {
    header: 'Ingresos',
    key: 'ingresos',
    width: 110
  },
  {
    header: 'Ganancia',
    key: 'ganancia',
    width: 110
  }];


  const data: PdfRow[] = (productStats || []).map((p: any) => ({
    producto: p.name || p.productName || '',
    unidades: Number(p.units || p.quantity || 0),
    ingresos: `RD$ ${Number(p.revenue || 0).toLocaleString('es-DO')}`,
    ganancia: `RD$ ${Number((p.revenue || 0) - (p.cost || 0)).toLocaleString('es-DO')}`
  }));
  data.push({
    producto: '── TOTAL ──',
    unidades: totals.units,
    ingresos: `RD$ ${totals.revenue.toLocaleString('es-DO')}`,
    ganancia: `RD$ ${totals.profit.toLocaleString('es-DO')}`
  });
  const ts = new Date().toISOString().split('T')[0];
  const suffix = dateFrom && dateTo ? `_${dateFrom}_${dateTo}` : '';
  await downloadFormattedPdf(
    data,
    columns,
    `estadisticas_productos${suffix}_${ts}.pdf`,
    'Estadísticas de Productos'
  );
};